import React, { Component } from "react";
import {
  NavLink,
  Switch,
  Route,
  BrowserRouter
} from "react-router-dom";
import { Helmet } from "react-helmet";

import Experience from "./pages/Experience";
import Readly from "./pages/Readly";
import Zettle from "./pages/iZettle";

import Home from "./home";
import Mathem from "./mathem";

import Cases from "./components/cases";
import Information from "./components/information";
import Gallery from "./components/gallery";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';

import Navigation from "./components/navigation";


import './App.css';

function App() {
  return (
    <Container fluid className="container-spacing">
      <BrowserRouter>
        <Route path="/"  component={Home} exact />
        <Route path="/mathem" component={Mathem}/>
      </BrowserRouter>
    </Container>

    /*
    <BrowserRouter>
      <Navigation />
      <div className="Content">
        <Switch>
          <Route exact path="/">
            <Experience />
          </Route>
          <Route path="/Readly">
            <Readly />
          </Route>
          <Route path="/Zettle">
            <Zettle />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
    */
    /*
    <HashRouter>
      <div className="Parent">
        <div className="Sidebar">
          <h1>Christian Ressör</h1>
          <Navigation></Navigation>
        </div>
        <div className="Content">
          <Route exact path="/" component={Experience}/>
          <Route path="/Readly" component={Readly}/>
          <Route path="/iZettle" component={Zettle}/>
        </div>
      </div>
    </HashRouter>
    */
  );
}

export default App;
